import { Receipt } from "../models/receipt/receipt";
import ApiService from "./api.service";

export class ReceiptService extends ApiService {
  constructor() {
    super(process.env.REACT_APP_api_endpoint!);
  }

  getReceipt(txId: string) {
    return this.get<Receipt>(`/v2/public/hailing/${txId}`);
  }

  cancelReceipt(txId: string) {
    return this.put<void>(`/v2/public/hailing/${txId}/cancel`);
  }

  getCancellationFee(txId: string) {
    return this.get<any>(`/v2/public/hailing/${txId}/cancellation_fee`);
  }
}